module.exports = __webpack_public_path__ + "img/T705.d78a0cc3.jpg";